import styled from "styled-components";

export const Page = styled.div`
  width: 100%;
  display: flex;
  height: 100vh;
`;

export const Main = styled.main`
  width: 100%;
`;
